import React from 'react';

// === Components === //
import ButtonLink from '@components/common/ButtonLink';
import Container from '@components/common/Container';

// === Styles === //
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { breakpoints, respondTo } from '@styles';

// === Types === //
import { Variant } from '@content/types/layout';

const Wrapper = styled.div`
  text-align: center;
  margin: 45px 0 60px 0;

  a {
    display: inline-block;
    width: auto;
    max-width: 448px;
    padding: 10px 85px;

    ${respondTo(
      breakpoints.md,
      css`
        max-width: 345px;
        padding: 10px;
      `
    )}
  }
`;

interface ButtonLinkWrapperProps {
  children: React.ReactChild;
  link: string;
  variant: Variant;
}

const ButtonLinkWrapper = ({ children, link, variant }: ButtonLinkWrapperProps) => {
  return (
    <Container>
      <Wrapper>
        <ButtonLink link={link} variant={variant}>
          {children}
        </ButtonLink>
      </Wrapper>
    </Container>
  );
};

export default ButtonLinkWrapper;
